import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const HeartOutline: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = '#000',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.30218C13.1256 4.44107 14.2643 3.62958 15.4679 3.24295C16.8634 2.79465 18.3133 2.92345 19.8995 3.99516C19.9132 4.00438 19.9264 4.01417 19.9392 4.0245C20.903 4.80129 21.8447 6.20912 21.9827 8.09996C22.1214 10.0007 21.4441 12.3172 19.3021 14.9075C17.4777 17.1137 14.8987 19.5795 12.2785 20.9304C12.2637 20.9383 12.2486 20.9455 12.2331 20.9521C12.1604 20.9834 12.0843 20.9989 12.0089 20.9999C11.9217 21.0013 11.833 20.9834 11.7493 20.9442C11.7406 20.9402 11.7321 20.936 11.7237 20.9315C9.1027 19.5808 6.52281 17.1143 4.69793 14.9075C2.55593 12.3172 1.87858 10.0007 2.01731 8.09997C2.15532 6.20912 3.097 4.80129 4.06076 4.02451C4.07357 4.01418 4.08682 4.00439 4.10047 3.99517C5.68668 2.92346 7.13656 2.79465 8.5321 3.24294C9.73568 3.62957 10.8744 4.44106 12 5.30218ZM15.8303 4.34828C16.8621 4.01685 17.9292 4.07804 19.2167 4.94089C19.9432 5.53499 20.6997 6.64934 20.8117 8.1837C20.9239 9.7214 20.3929 11.7537 18.3935 14.1715C16.6819 16.2414 14.3347 18.4825 12 19.7595C9.66526 18.4825 7.31814 16.2414 5.60649 14.1715C3.60712 11.7537 3.07611 9.7214 3.18834 8.1837C3.30034 6.64935 4.0568 5.53499 4.7833 4.9409C6.07084 4.07804 7.13795 4.01685 8.16966 4.34827C9.26731 4.70087 10.3544 5.50449 11.6293 6.48875C11.7326 6.57223 11.86 6.61657 11.989 6.61905C12.082 6.62084 12.1758 6.60086 12.2622 6.55808C12.3001 6.5394 12.3362 6.5165 12.3698 6.48947C13.6451 5.50489 14.7324 4.70097 15.8303 4.34828Z"
        fill={color}
      />
    </svg>
  );
};

export default HeartOutline;
